import api from 'src/services/api';
import * as utils from './apiUtils';
import type {
  MovieSearchParams,
  MovieSearchContinuedMoviesParams,
  MovieSearchByRoutesParams,
  MovieSearchByAreaParams,
} from 'src/models/apis/movie/movieRequest';
import {
  type MovieGetMovieFilesResponse,
  type MovieSearchResponse,
  type MovieSearchByRoutesResponse,
  type ContinuedMoviesResponse,
  toMovie,
  toMovieList,
  toMovieGetMovieFiles,
  toRouteSearchMovieList,
} from 'src/models/apis/movie/movieResponse';
import type {
  Movie,
  MovieList,
  MovieGetMovieFiles,
  RouteSearchMovieList,
} from 'src/models/movie';

export default {
  async getMovieFiles(id: number): Promise<MovieGetMovieFiles> {
    const response = await api.get<MovieGetMovieFilesResponse>(utils.getApiUrl(`/movies/${id}/files`));
    return toMovieGetMovieFiles(response.data);
  },
  async search(params: MovieSearchParams): Promise<MovieList[]> {
    const response = await api.get<MovieSearchResponse>(utils.getApiUrl('/movies/search'), { params });
    return response.data.map(toMovieList);
  },
  async searchContinuedMovies(params: MovieSearchContinuedMoviesParams): Promise<Movie[]> {
    const response = await api.get<ContinuedMoviesResponse>(
      utils.getApiUrl('/movies/search_continued_movies'),
      { params },
    );
    return response.data.map(toMovie);
  },
  async searchByRoutes(params: MovieSearchByRoutesParams): Promise<RouteSearchMovieList[]> {
    const response = await api.get<MovieSearchByRoutesResponse>(utils.getApiUrl('/movies/search_by_routes'), { params });
    return response.data.map(toRouteSearchMovieList);
  },
  async searchByArea(params: MovieSearchByAreaParams): Promise<MovieList[]> {
    const response = await api.get<MovieSearchResponse>(utils.getApiUrl('/movies/search_by_area'), { params });
    return response.data.map(toMovieList);
  },
  async searchByMovieId(id: number): Promise<MovieList[]> {
    const response = await api.get<MovieSearchResponse>(utils.getApiUrl('/movies/search_by_movie_id'), {
      params: { id },
    });
    return response.data.map(toMovieList);
  },
};
